import projection from '../generated/pwj5m2f1.json'; import { AcceptanceManifest } from '../types';
export const pwj5m2f1AcceptanceManifest = projection as AcceptanceManifest;
